import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
/////////////
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
//////////////
import DeleteIcon from "@mui/icons-material/Delete";

export default function DiagnosisTable(props) {
  let { AllDiagnosis } = props;
  return (
    <TableContainer
      sx={{ width: "70%", margin: "10px auto", "& td": { border: 0 } }}
      component={Paper}
    >
      <Table aria-label="simple table">
        <TableHead
          sx={{
            backgroundColor: "#1976d2 !important",
            color: "white !important",
          }}
        >
          <TableRow>
            <TableCell
              sx={{
                color: "white !important",
              }}
              align="center"
            >
              Diagnosis Type
            </TableCell>
            <TableCell
              sx={{
                color: "white !important",
              }}
              align="center"
            >
              Diagnosis Code
            </TableCell>
            {props.deleteFlag ? <TableCell align="center"></TableCell> : null}
          </TableRow>
        </TableHead>
        <TableBody>
          {AllDiagnosis.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="center">
                {row.diagnosisType == "principal" ? "Principal" : "Secondary"}
              </TableCell>
              <TableCell align="center">{row.diagnosisCode}</TableCell>
              {props.deleteFlag ? (
                <TableCell align="center">
                  <DeleteIcon
                    onClick={(e) => {
                      props.deleteDiagnosisElement(index);
                    }}
                  />
                </TableCell>
              ) : null}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
